import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { HelperService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-ro-card',
  templateUrl: './ro-card.component.html',
  styleUrls: ['./ro-card.component.scss'],
})
export class RoCardComponent implements OnInit {
  @Input() data: any = {};
  @Input() index: any;
  usd: string = currency.USD;

  constructor(private helperService: HelperService) {}
  ngOnInit() {}

  openRO(roData) {
    if (roData.type == 'orderLevel') {
      this.helperService.openPageInNewExistingTab(`/estimate/${roData.roId}`, roData._id);
    }
  }
}
